import { AlgoliaTrackingService } from "@services/algolia/tracking/algoliaTracking.service";
import { TypedAnalyticsEvent } from "@services/tracking/types/analyticsEvent";
import { SearchFilterTrackingInfo } from "@services/tracking/types/trackingInfo/searchFilterTrackingInfo";

import {
    AlgoliaAnalyticsEventNames,
    AlgoliaAnalyticsEvents,
} from "../AlgoliaAnalyticsEvents";
import {
    AlgoliaAnalyticsMinimumDataset,
    AlgoliaFilterClickedPayload,
} from "../AlgoliaAnalyticsMinimumDataset";

export interface AlgoliaAnalyticsSearchFilterImpression
    extends AlgoliaAnalyticsMinimumDataset<AlgoliaFilterClickedPayload> {}

const getAlgoliaProductFilterAppliedPayload = (
    eventData: SearchFilterTrackingInfo,
): AlgoliaFilterClickedPayload => {
    let filter = decodeURIComponent(eventData.filter).split(":");

    return {
        authenticatedUserToken:
            AlgoliaTrackingService.getAuthenticatedUserToken(),
        eventName: AlgoliaAnalyticsEventNames.FilterApplied,
        index: eventData.index,
        userToken: AlgoliaTrackingService.getUserToken(),
        filters: [
            filter.length !== 2
                ? eventData.filter
                : `${encodeURIComponent(filter[0])}:${encodeURIComponent(
                      filter[1],
                  )}`,
        ],
    };
};

const getAlgoliaAnalyticsSearchFilterImpression = (
    data: TypedAnalyticsEvent<SearchFilterTrackingInfo>,
): Array<AlgoliaAnalyticsSearchFilterImpression> => {
    const payload = getAlgoliaProductFilterAppliedPayload(
        data.payload.eventData,
    );

    return [
        {
            eventName: AlgoliaAnalyticsEvents.ClickedFilters,
            payload: payload,
        },
    ];
};

export { getAlgoliaAnalyticsSearchFilterImpression };
